const initialize = () => {
    const passwords = document.querySelectorAll('.password-toggle');
    passwords.forEach(function(elem) {
        if (elem.querySelector('.password-icon')) {
            elem.querySelector('.password-icon').addEventListener('click', function(event) {
                const iconEl = elem.querySelector('.password-icon');
                const passEl = elem.parentNode.querySelector('.password-text');
                if (iconEl.classList.contains('fa-eye-slash')) {
                    iconEl.className = 'password-icon fa fa-eye';
                    passEl.textContent = "*".repeat(passEl.getAttribute('data-password').length);
                } else {
                    iconEl.className = 'password-icon fa fa-eye-slash';
                    passEl.textContent = passEl.getAttribute('data-password');
                }
            });
        }
    });

    const syncLogModal = document.querySelector('.sync-logs-modal');


    function updateSyncInfo() {
        const userSyncInfoApiEndpoint = syncLogModal.getAttribute('data-sync-info-url');
        const syncLogTextarea = syncLogModal.querySelector('textarea');
        syncLogTextarea.textContent = syncLogModal.getAttribute('data-i18n-loading');
        fetch(userSyncInfoApiEndpoint, {
            credentials: 'same-origin',
            headers: {
                'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest'
            },
        })
            .then(response => response.json())
            .then(function(responseData) {
                // console.log(responseData);
                const mailsyncLogItem = responseData?.data?.lastLogItem?.logs || {};
                let textareaContents = '';
                for (const dateProperty in mailsyncLogItem) {
                    textareaContents += dateProperty + ' - ' + mailsyncLogItem[dateProperty] + "\n";
                    if (
                        (Array.isArray(mailsyncLogItem[dateProperty]) && mailsyncLogItem[dateProperty].includes('Sync started')) ||
                        (typeof mailsyncLogItem[dateProperty] === 'string' && mailsyncLogItem[dateProperty].includes('Sync started'))
                    ) {
                        textareaContents += dateProperty + ' - ' + responseData?.data?.lastLogItem?.syncOutput + "\n";
                    }
                }
                if (!textareaContents) {
                    textareaContents = 'no logs yet...';
                }
                //update sync log data here in textarea
                syncLogTextarea.textContent = textareaContents;
                //scroll to bottom as there is most recent info
                syncLogTextarea.scrollTop = syncLogTextarea.scrollHeight;
            });
    }
    if (syncLogModal) {
        syncLogModal.addEventListener('shown.bs.modal', function () {
            //on modal open create ajax request to get sync log
            updateSyncInfo();

            const autoRefreshLogsCheckbox = document.getElementById("autoRefreshLogs");
            setInterval(() => {
                if (autoRefreshLogsCheckbox.checked) {
                    updateSyncInfo();
                }
            }, 10000);
        });
    }
};

export default initialize;

